// ============================================================================
// ReactionPicker.tsx — панель выбора реакции на сообщение (SRP: вынесена из
// MessageBubble). Содержимое — SSoT-реестр reactionPictures: SVG из ветки
// «Картинки», а при недоступной библиотеке — встроенный детерминированный
// набор (reactionDisplay: url либо эмодзи-символ). Пустой панели не бывает.
// ============================================================================

import { motion } from 'framer-motion';
import { reactionCodes, reactionDisplay } from '@/lib/reactionPictures';

interface Props {
  open: boolean;
  /** Версия картинок реакций (перерисовка, когда SVG доехали из «Картинок») */
  rxVersion: number;
  onPick: (code: string) => void;
}

export function ReactionPicker({ open, rxVersion, onPick }: Props) {
  if (!open) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: 'spring', stiffness: 400, damping: 24 }}
      onClick={(e) => e.stopPropagation()}
      className="flex items-center gap-0.5 flex-wrap justify-center mb-1.5 p-1 rounded-xl border"
      style={{ background: 'var(--color-muted)', borderColor: 'var(--color-border)' }}
      data-rx-version={rxVersion}
    >
      {reactionCodes().map((code) => {
        const { url, char, label } = reactionDisplay(code);
        return (
          <motion.button
            key={code}
            whileHover={{ scale: 1.25, y: -2 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: 'spring', stiffness: 500, damping: 18 }}
            title={label}
            className="h-8 w-8 rounded-full flex items-center justify-center hover:bg-black/10 dark:hover:bg-white/10 transition-colors"
            onClick={(ev) => { ev.stopPropagation(); onPick(code); }}
          >
            {url ? (
              <img src={url} alt={label} draggable={false} className="h-6 w-6 object-contain" />
            ) : (
              <span className="text-base leading-none">{char}</span>
            )}
          </motion.button>
        );
      })}
    </motion.div>
  );
}
